var React = require('react');

function ChevronRight12 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M4.0043 0L10.0043 6L4.0043 12L2.59009 10.5858L7.17509 6L2.59009 1.41421L4.0043 0Z","fill":"currentColor"}));
}

ChevronRight12.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none"};

module.exports = ChevronRight12;

ChevronRight12.default = ChevronRight12;
